import { useEffect, useState } from 'react';
import type { Editor } from '../editor';
import { COMMAND_GROUPS } from '../commands/registry';

/**
 * 도구막대 (작업지시서 P2-14)
 *
 * ⚠️ 이것은 "여러 시스템을 오가는 전역 사이드바"가 아니라 시스템 고유 기능이므로
 *    iframe 안에서도 숨기지 않는다 (통합표준 3절 / v2 §1.2).
 */
export function Toolbar({ editor }: { editor: Editor }) {
  const [, setTick] = useState(0);
  useEffect(() => editor.subscribe(() => setTick((t) => t + 1)), [editor]);

  const active = editor.snapshot().commandName;

  return (
    <div className="cad-toolbar" role="toolbar" aria-label="CAD 도구">
      {COMMAND_GROUPS.map((g) => (
        <div className="cad-toolbar__group" key={g.title}>
          <div className="cad-toolbar__title">{g.title}</div>
          {g.commands.map((c) => (
            <button
              key={c.name}
              type="button"
              className="cad-toolbar__btn"
              aria-pressed={active === c.name}
              title={`${c.label} (${[c.name, ...c.aliases].join(' / ')})${c.hint ? ` — ${c.hint}` : ''}`}
              onClick={() => editor.startCommand(c.name)}
            >
              <span className="cad-toolbar__label">{c.label}</span>
              <span className="cad-toolbar__alias">{c.aliases[0] ?? c.name}</span>
            </button>
          ))}
        </div>
      ))}

      <div className="cad-toolbar__group">
        <div className="cad-toolbar__title">화면</div>
        <button
          type="button"
          className="cad-toolbar__btn"
          title="도면 전체 보기 (캔버스 더블클릭)"
          onClick={() => editor.zoomExtents()}
        >
          <span className="cad-toolbar__label">전체 보기</span>
          <span className="cad-toolbar__alias">ZE</span>
        </button>
        <button
          type="button"
          className="cad-toolbar__btn"
          title="선택한 것만 확대"
          onClick={() => editor.zoomSelection()}
        >
          <span className="cad-toolbar__label">선택 확대</span>
          <span className="cad-toolbar__alias">ZS</span>
        </button>
      </div>
    </div>
  );
}
